<template>
  <article class="container-fluid">
    <ValidationObserver ref="form">
      <div v-if="!disabled" class="filter-container mt-2">
        <form novalidate>
          <div class="row">
            <div :class="['col-4 col-md-4']">
              <ValidationProvider
                ref="itemToAddValidator"
                v-slot="{ errors }"
                name="Escuela"
                :rules="`${searchField === '' ? 'required' : ''}`"
              >
                <custom-input
                  id="txtLocationName"
                  v-model="searchField"
                  placeholder="Escriba Nombre del Estudiante o Numero de SIE"
                  icon="fa fa-search orange-icon"
                  custom-error-msg="Favor escriba el nombre o número de SIE del estudiante para obtener resultados de la búsqueda."
                  :error="errors[0]"
                  left-icon
                />
              </ValidationProvider>
            </div>
            <div :class="['col-1 col-md-6']">
              <div>
                <ActionButton
                  id="action-btn"
                  variant="outline-danger"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="cancel()"
                />
                <action-button
                  text="Buscar"
                  class="ml-3"
                  variant="success"
                  i="fas fa-search"
                  :class="['px-4']"
                  @click="searchStudents()"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <AssignedStudentRow
        :key="assignedComponentKey"
        :student-list="collections.studentList"
        :disabled="disabled"
      />
    </ValidationObserver>
  </article>
</template>

<script>
import alert from "@/mixin/alert.mixin";
import AssignedStudentRow from "./components/AssignedStudentRow";
import AddStudent from "./components/AddStudent";
import CustomInput from "@/components/common/CustomInput";
import ActionButton from "@/components/common/ActionButton";
import { getServiceAssistantsStudents } from "@/modules/service-assitant/api";

export default {
  name: "Students",
  mixins: [alert],
  components: {
    AssignedStudentRow,
    AddStudent,
    CustomInput,
    ActionButton
  },
  props: {
    hrAssistantId: {
      type: String,
      required: true
    },
    assistantId: {
      type: Number,
      required: true
    },
    schoolId: {
      type: Number,
      required: true
    },
    collections: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    academicYearId: { type: [Number, String], default: 0 }
  },
  data() {
    return {
      keyComponent: 0,
      searchField: "",
      assignedComponentKey: 0
    };
  },
  computed: {
    getStudents() {
      return this.collections.studentList;
    }
  },
  methods: {
    addStudent() {
      let params = {
        AssistantContractNumber: this.hrAssistantId
      };
      this.doSearch(params);
    },
    async cancel() {
      this.searchField = "";
      let params = {
        AssistantContractNumber: this.hrAssistantId,
        SearchField: "",
        AcademicYearId: this.academicYearId,
        AssistantId: this.assistantId,
        SchoolId: this.schoolId
      };
      this.doSearch(params);
    },
    async doSearch(params, inList = false) {
      await getServiceAssistantsStudents(params).then(res => {
        this.collections.studentList = [];
        res.data.data.forEach(student => {
          this.collections.studentList.push({
            id: student.id,
            sie: student.sie,
            name: `${student.firstName} ${student.lastName}`,
            age: student.age,
            gade: student.grade,
            impediment: student.impedimentDescription,
            ubicationAlternative: student.ubicationDescription,
            requestNumber: student.requestNumber,
            necesities: student.necesities,
          });
          this.assignedComponentKey++;
        });
        if (!inList) {
          this.$emit("refreshCount", this.collections.studentList.length);
        }

        this.$refs.itemToAddValidator.reset();
      });
    },
    async searchStudents() {
      if (!(await this.$refs.itemToAddValidator.validate()).valid) return;
      let params = {
        AssistantContractNumber: this.hrAssistantId,
        SearchField: this.searchField,
        AssistantId: this.assistantId,
        SchoolId: this.schoolId
      };
      this.doSearch(params, true);
    }
  },
  async mounted() {
    this.collections.studentList = [];
    this.assignedComponentKey++;
    let params = {
      AssistantContractNumber: this.hrAssistantId,
      AcademicYearID: this.academicYearId,
      AssistantId: this.assistantId,
      SchoolId: this.schoolId
    };
    this.doSearch(params);
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

#action-btn:not(:hover) {
  background-color: transparent;
}

.filter-container {
  background-color: $gray;
  padding: 15px;
  border-radius: 5px;
}
.box-result-field-value {
  font-weight: bold;
}
.student-count {
  color: map.get($colors, "orange");
}
.add-student-button {
  background-color: transparent;
}
</style>
